import AtomicTypography from "../components/atoms/Typography";
import CustomizedTable from "../components/organisms/Table";
import AtomicButton from "../components/atoms/Button";
import { useEffect, useState } from "react";
import html2canvas from "html2canvas";
import { Dimension, ResultTable } from "../types/types";
import { TableCell, styled, tableCellClasses, Grid } from "@mui/material";
import AtomicAppBar from "../components/molecules/AppBar";
import Chart from "../components/organisms/Chart";
import { Link } from "react-router-dom";
import apiOperation from "../apihelper/api-operation";
import "../styles/App.css";
import AtomicLogo from "../components/atoms/Logo";
import CIMATRICROPLOGO from "../CIMATRICroplogo.png";
import { pdf } from "@react-pdf/renderer";
import PdfGenerator from "../components/organisms/pdfGenerator";
import { Base_AI_WORKSHOP_URL } from "../config/config";
import axios from "axios";
import CircularProgressBar from "../components/atoms/CircularProgressBar";

const Result: React.FC = () => {
  const AI_WORKSHOP = Base_AI_WORKSHOP_URL;
  //below is data mapping from updatedDimensions state
  const [tableData, setTableData] = useState<ResultTable[]>([]);
  const [chartImage, setChartImage] = useState("");
  const userEmail = localStorage.getItem("userEmail");
  const [finalPercentage, setFinalPercetage] = useState<any>([]);
  const [isSendingData, setIsSendingData] = useState(false);
  const [uploadedPdfUrl, setUploadedPdfUrl] = useState<string>("");
  const [waitIndicator, setWaitIndicator] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const   errorMessageText:string="Internal server error."
  useEffect(() => {
    const updatedDimensions: Dimension[] = JSON.parse(
      localStorage.getItem("updatedDimensions") || "{}"
    );
    // Check if updatedDimensions data is available
    if (updatedDimensions && updatedDimensions.length > 0) {
      // Prepare the data to match the ResultTable structure
      const formattedData: ResultTable[] = updatedDimensions.map(
        (dimension: any) => ({
          // Map relevant properties from dimension to ResultTable structure
          dimensionID: dimension.ID,
          dimension: dimension.Name,
          level: dimension.Level,
          levelID: dimension.LevelId,
          FinalLevel: dimension.FinalLevel,
          percentage: dimension.Percentage,
          narrative: dimension.Narrative,
        })
      );
      // Set the formatted data to the local state
      setTableData(formattedData);
      const numberofdimension = updatedDimensions?.length | 6;
      const totalsum = formattedData.reduce(
        (sum: any, dimension) => sum + dimension.percentage,
        0
      );
      const percentage = (totalsum / numberofdimension).toFixed(2);
      // API call to get the level by the total percentage
      getLevelByPercentage(percentage);
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  //below useEffect is being use to convert pdf into blob data and pass it to server

  useEffect(() => {
    if (!isSendingData) sendBlobToServer();
  }, [chartImage,tableData,finalPercentage]);

  //convert pdfGenerator component into blob data
  const pdfBlobData = async () => {
    const pdfElement = (
      <PdfGenerator
        jsonResult={tableData}
        LevelName={finalPercentage[0]?.Level}
        chartImage={chartImage}
      />
    );
    // Use the pdf function to convert the React element to a PDF document
    const pdfDocument = pdf(pdfElement);
    // Convert the PDF document to a blob
    const pdfBlob = await pdfDocument.toBlob();
    return pdfBlob;
  };

  const sendBlobToServer = async () => {
    try {
      const  LevelName = finalPercentage[0]?.Level;
      if (chartImage && LevelName && tableData && finalPercentage) {
        //check userEmail is null or not if not then file name should be userEmail_aimm_report.pdf else aimm_report.pdf
        const pdfName: string = userEmail
          ? `${userEmail}_aimm_report.pdf`
          : "aimm_report.pdf";

        const pdfBlob = await pdfBlobData();

        // Create a FormData object and append the blob data
        const formData = new FormData();
        formData.append("file", pdfBlob, pdfName);
        const config = { headers: { "Content-Type": "multipart/form-data" } };

        // Use axios.post with FormData
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/uploadFile`,
          formData,
          config
        );
        if (response.status === 200) {
          setIsSendingData(true);
          setUploadedPdfUrl(response.data.uploadedFileUrl);
          setWaitIndicator(false);
          setErrorMessage("");
          console.log(
            "Uploaded result file successfully on azure!: ",
            response?.statusText
          );
        } else {
          setWaitIndicator(false);
          setErrorMessage(errorMessageText);
          console.log(
            "Error occured while uploading result file: ",
            response?.statusText
          );
        }
      }
      else
      {
        console.log("Data is not available for pdf generation");
        setErrorMessage(errorMessageText);
      }
    } catch (err) {
      setIsSendingData(false);
      setWaitIndicator(false);
      setErrorMessage(errorMessageText);
      console.log("Error is here: ", err);
    }
  };

  const getLevelByPercentage = async (totalPercentage: any) => {
    apiOperation.url = `levelByPercentage/${totalPercentage}`;
    const levelData = await apiOperation.getAll();

    setFinalPercetage((prevSelectedPercentage: any) => [
      {
        ...prevSelectedPercentage[0],
        Level: levelData.Name, // Update Level with the level Name
        LevelId: levelData.ID, // Update LevelId with the level ID
      },
    ]);
  };
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#45C2B1",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 17,
    },
  }));

  //const LevelName = finalPercentage[0]?.Level;

  const createChartImage = async () => {
    try {
  
      const chartContainer = document.querySelector(
        ".chart-container"
      ) as HTMLElement;

      if(chartContainer.innerHTML.includes("dimensionRadar")){
        const canvas = await html2canvas(chartContainer, { scale: 2 });
      const chartImage = canvas.toDataURL("image/png");

      // Pass the chart image data to PdfGenerator component
      console.log("Chart image captured successfully!");

      setChartImage(chartImage);
      }else{
        console.log("Chart container not found");
      }
      
    } catch (error) {
      console.error("Error capturing chart:", error);
    }
  };

  // Here start of code added for disable back button on result page

  const url: string[] = window.location.href?.split("/");

  if (url.length > 0 && url[3]?.toLowerCase() === "result") {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function () {
      window.history.go(1);
    };
  }
  //  Here End of code added for disable back button on result page
  return (
    <>
      {waitIndicator && ( // Render loading spinner when isLoading is true
        <CircularProgressBar />
      )}
      <Grid item xs={12}>
        <AtomicAppBar />
      </Grid>
      <Grid container spacing={2} paddingLeft={3} paddingRight={3}>
        {/* first element of main parent grid */}
        <Grid
          item
          xs={12}
          container
          direction="row"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          marginTop="-1%"
          marginBottom="2%"
        >
          <AtomicTypography
            style={{
              fontSize: "2.5rem",
              color: "#000080",
            }}
          >
            AI Maturity Assessment for Associations
          </AtomicTypography>

          <Grid
            item
            xs={12}
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
          >
            <AtomicTypography
              style={{
                fontSize: "1.7rem",
              }}
            >
              Your Overall Artificial Intelligence Maturity is{" "}
            </AtomicTypography>
            <span>&nbsp;</span>
            <AtomicTypography
              style={{
                fontSize: "1.7rem",
                color: "green",
              }}
            >
              {finalPercentage[0]?.Level}
            </AtomicTypography>
          </Grid>
        </Grid>

        {/* contains table and chart logic */}
        <Grid
          container
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          spacing={3}
          direction="row"
        >
          {/* table logic */}
          <Grid item xs={12} sm={12} md={12} lg={4.5} xl={5}>
            <CustomizedTable
              jsonResult={tableData}
              StyledTableCell={StyledTableCell}
            />
          </Grid>
          {/* Chart logic */}
          {tableData && (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={7.5}
              xl={7}
              sx={{
                marginTop: {
                  xs: "1.5rem",
                  sm: "1.7rem",
                  md: "1.8rem",
                },
              }}
              className="chart-container"
            >
              <Chart
                
                jsonResult={tableData}
                createChartImage={createChartImage}
              />
            </Grid>
          )}
        </Grid>

        {/* logic for Dimension names and narrative */}
        {tableData.map((item) => (
          <Grid
            container
            item
            key={item.dimensionID}
            direction="row"
            spacing={1}
            wrap="nowrap"
            sx={{
              marginTop: {
                xl: "2rem",
                lg: "1.8rem",
              },
            }}
          >
            {/* logic for mapping dimensions */}
            <Grid item xs={5.5} sm={4} md={3} lg={3} xl={2.3}>
              <AtomicTypography
                sx={{
                  fontSize: {
                    xl: "1.4rem",
                    lg: "1.2rem",
                    md: "1.1rem",
                    sm: "1rem",
                    xm: "0.2rem",
                  },
                  marginTop: "1.7rem",
                  fontWeight: "bold",
                  color: "#333",
                }}
              >
                {item.dimension}
              </AtomicTypography>
            </Grid>
            {/* Logic for mapping narratives */}
            <Grid item xs={6.5} sm={8} md={9} lg={9} xl={9.7}>
              <AtomicTypography
                sx={{
                  fontSize: {
                    xl: "1.3rem",
                    lg: "1.1rem",
                    md: "1rem",
                    sm: "0.9rem",
                    xm: "0.3rem",
                  },
                  marginTop: "1.7rem",
                  color: "#666",
                }}
              >
                {item.narrative}
              </AtomicTypography>
            </Grid>
          </Grid>
        ))}
        <Grid
          item
          xs={12}
          container
          direction="row"
          alignItems="center"
          justifyContent="center"
          marginTop={5}
        >
          <Grid>
            <AtomicTypography
              sx={{
                fontSize: {
                  xl: "2rem",
                  lg: "1.8rem",
                  md: "1.6rem",
                  sm: "1.4rem",
                  xs: "1rem",
                },
              }}
            >
              “Let us help you get started!”
            </AtomicTypography>
          </Grid>
          <Grid
            container
            item
            direction="row"
            wrap="nowrap"
            alignItems="center"
            justifyContent="center"
            // spacing={1}
            marginTop={1}
            marginBottom={4}
            textAlign="center"
          >
            <Grid item>
              <AtomicLogo
                logoSrc={CIMATRICROPLOGO}
                altText="Cimatri crop logo"
                imageStyle={{
                  width: "1rem",
                  height: "1rem",
                }}
              />
            </Grid>
            <Grid>
              <AtomicTypography
                sx={{
                  fontSize: {
                    xl: "1.3rem",
                    lg: "1.1rem",
                    md: "1rem",
                    sm: "0.9rem",
                    xs: "0.62rem",
                  },
                }}
              >
                <Link
                  to={AI_WORKSHOP ?? " "}
                  target="_blank" // Open the link in a new tab
                  rel="noopener noreferrer" // Necessary for security and performance reasons
                  style={{
                    textDecoration: "none",
                  }}
                >
                  Plan An AI Workshop Tailored to Your Association
                </Link>
              </AtomicTypography>
            </Grid>
          </Grid>
          <Grid marginBottom={3}>
            {/* {uploadedPdfUrl ? ( */}
            <a
              href={uploadedPdfUrl}
              download={`${userEmail}_results.pdf`}
              style={{ textDecoration: "none" }}
            >
              <AtomicButton
                className="progress-modal-download-button"
                text={<span>Download</span>}
              />
            </a>
            {/* ) : (
              <AtomicButton
                className="progress-modal-download-button"
                text={<span>Download</span>}
                disabled
              />
            )} */}
          </Grid>          
        </Grid>
        {errorMessage&&
        <Grid marginBottom={3}  direction="row"
          item
          xs={12}
          container
          alignItems="center"
          justifyContent="center"
          
          >
          <AtomicTypography
                sx={{
                  fontSize: {
                    xl: "1.3rem",
                    lg: "1.1rem",
                    md: "1rem",
                    sm: "0.9rem",
                    xs: "0.62rem",
                  },
                  color: "red",
                }}
               >   
               {errorMessage}  &nbsp;
                  <Link
                  to={process.env?.REACT_APP_APPLICATION_URL?process.env?.REACT_APP_APPLICATION_URL:""}
                  target="_blank" // Open the link in a new tab
                  rel="noopener noreferrer" // Necessary for security and performance reasons
                  style={{
                    textDecoration: "none",
                  }}
                >
                  Please try again
                </Link> 
              </AtomicTypography>
              </Grid>}
      </Grid>
    </>
  );
};
export default Result;
